import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import styles from "../CommonStyles/commonstylesDetails.module.scss";
import { useFetchPartnerDetails } from "../../../../hooks/partnerHook/usePartner";
import { RiDeleteBin5Line } from "react-icons/ri";
import DeleteBox from "../../../../components/DeleteBox/DeleteBox";
import { useDeleteKyc } from "../../../../hooks/partnerHook/usePartnerKyc";
import { useSelector } from "react-redux";

const KycDocumentDetail = () => {
  const { kycId } = useParams();
  const navigate = useNavigate();
  const { data: partnerData, isLoading, isError } = useFetchPartnerDetails();

  const kyc = useSelector((state) =>
    state.partner.kyc.find((doc) => doc.kyc_id.toString() === kycId)
  );

  const {
    mutate: deleteKyc,
    isSuccess: kycDeleted,
    isError: deletionError,
  } = useDeleteKyc();

  const [showDeleteModal, setShowDeleteModal] = useState(false);

  if (isLoading) return <h2>Loading KYC Details...</h2>;
  if (isError || !kyc) return <h2>Error: KYC not found!</h2>;

  const handleDelete = () => {
    deleteKyc({ partnerId: partnerData?.partner?.id, kycId });
    setShowDeleteModal(false);
    navigate("/dashboard/kycdocuments");
  };

  return (
    <div className={styles.detailsContainer}>
      <div className={styles.titleContainer}>
        <h2 className={styles.equipmentTitle}>{`${kyc.first_name} ${kyc.last_name}`}</h2>
        <RiDeleteBin5Line
          className={styles.deleteIcon}
          onClick={() => setShowDeleteModal(true)}
        />
      </div>

      <div className={styles.imageCard}>
        <img
          src={kyc.doc_url || "/default-image.jpg"}
          alt={kyc.doc_type}
          className={styles.equipmentImage}
        />
        <span
          className={`${styles.verificationStatus} ${
            kyc.verification_status === "success"
              ? styles.verified
              : styles.notVerified
          }`}
        >
          {kyc.verification_status === "success"
            ? "Verified"
            : "Not Verified"}
        </span>
      </div>

      <div className={styles.equipmentDetails}>
        <div className={styles.detailItem}>
          <strong>Document Number:</strong> <span>{kyc.doc_number}</span>
        </div>
        <div className={styles.detailItem}>
          <strong>Document Origin:</strong> <span>{kyc.doc_origin}</span>
        </div>
        <div className={styles.detailItem}>
          <strong>Document Type:</strong> <span>{kyc.doc_type}</span>
        </div>
        <div className={styles.detailItem}>
          <strong>Email:</strong> <span>{kyc.email}</span>
        </div>
        <div className={styles.detailItem}>
          <strong>Phone:</strong> <span>{kyc.phone_number}</span>
        </div>
        <div className={styles.detailItem}>
          <strong>Verified:</strong> <span>{kyc.is_verified ? "Yes" : "No"}</span>
        </div>
        <div className={styles.detailItem}>
          <strong>Selfie:</strong><br />
          <img
            src={kyc.selfie_url || "/default-selfie.jpg"}
            alt="Selfie"
            className={styles.equipmentImage}
          />
        </div>
        <div className={styles.detailItem}>
          <strong>Verification Notes:</strong>{" "}
          <span>{kyc.verification_notes || "None"}</span>
        </div>
      </div>

      {showDeleteModal && (
        <DeleteBox
          deleteFunction={handleDelete}
          isSuccess={kycDeleted}
          isError={deletionError}
          contentName={`${kyc.first_name} ${kyc.last_name}'s document`}
          setShowDeleteModal={setShowDeleteModal}
        />
      )}
    </div>
  );
};

export default KycDocumentDetail;
